import styled from 'styled-components'

export const SupportButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  flex-shrink: 0;
  height: 60px;

  @media (max-width: 900px) {
    font-size: 14px;
    gap: 8px;
    min-width: 200px;
    height: 50px;
  }

  @media (max-width: 900px) {
    display: none;
  }
`

export const KambaSupport = styled.div`
  white-space: nowrap;
  margin-right: 10px;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;

  @media (max-width: 900px) {
    margin-right: 8px;
    font-size: 11px;
    line-height: 18px;
  }

  @media (max-width: 600px) {
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.8px;
  }
`

export const ResponsiveContainer = styled.div`
  margin-top: -30px;
  height: 100%;

  @media (max-width: 900px) {
    margin-top: -15px;
  }
`
